// src/pages/AuthCallback.js
// Firebase popup auth handles its own flow — no redirect callback needed.
import { Navigate } from 'react-router-dom';

const AuthCallback = () => <Navigate to="/library" replace />;

export default AuthCallback;
